<template>
  <div class="content">
    <h3 ref="pageHeader"   class="pageHeader">数据报表</h3>
    <div class="flex-div">
      <!-- <div class="f-item1">
        <p class="p-title"><i class="el-icon-s-help"></i>{{$store.state.themeTitle}}室利用率以及上课率</p>
        <div class="div-style">
          <div id="pieOfUse">
            <v-chart theme="macarons" :options="pieUseOption" style="margin:0 atuo;" />
          </div>
          <div id="pieOfClass">
            <v-chart theme="macarons" :options="pieClassOption" style="margin:0 atuo;" />
          </div>
        </div>
      </div> -->
      <div class="f-item">
        <p class="p-title"><i class="el-icon-s-help"></i>{{$store.state.themeTitle}}室利用率 <span @click="handlePath('/trainingRoom')" style="float:right;cursor: pointer;">前往列表</span></p>
        <div class="ul-div" id="pieOfUse">
          <v-chart theme="macarons" :options="pieUseOption" style="margin:0 atuo;" />
        </div>
        <!-- <div id="pieOfClass">
            <v-chart theme="macarons" :options="pieClassOption" style="margin:0 atuo;" />
          </div> -->
      </div>
      <div class="f-item">
        <p class="p-title"><i class="el-icon-s-data"></i>{{$store.state.themeTitle}}室设备使用情况 <span @click="handlePath('/EquipmentCounts')" style="float:right;cursor: pointer;">前往列表</span></p>
        <div class="ul-div" id="barEqOption">
          <v-chart theme="macarons" :options="barEqOption" style="margin:0 atuo;" />
        </div>
      </div>
      <!-- <div class="f-item">
        <p class="p-title"><i class="el-icon-s-data"></i>{{$store.state.themeTitle}}室设备损耗情况<span @click="handlePath('/EquipmentScrap')" style="float:right;cursor: pointer;">前往列表</span></p>
        <div class="ul-div">
          <v-chart theme="macarons" :options="barEqSHOption" style="margin:0 atuo;" />
        </div>
      </div>
      <div class="f-item">
        <p class="p-title"><i class="el-icon-s-marketing"></i>学生实训考勤情况</p>
        <div class="ul-div" id="barEqOption">
          <v-chart theme="macarons" :options="lineOption" style="margin:0 atuo;" />
        </div>
      </div> -->
      <!-- <div class="f-item">
        <p class="p-title"><i class="el-icon-s-marketing"></i>老师{{$store.state.themeTitle}}室授课情况</p>
        <div class="ul-div" id="barEqOption">
          <v-chart theme="macarons" :options="lineTOption" style="margin:0 atuo;" />
        </div>
      </div> -->
      <div class="f-item">
        <p class="p-title"><i class="el-icon-s-data"></i>{{$store.state.themeTitle}}室设备及资产情况<span @click="handlePath('/trainingRoom')" style="float:right;cursor: pointer;">前往列表</span></p>
        <div class="ul-div" id="barEqOption">
          <v-chart theme="macarons" :options="barEqZJOption" style="margin:0 atuo;" />
        </div>
      </div>
      <!-- <div class="f-item">
        <p class="p-title"><i class="el-icon-s-data"></i>实训耗材数据明细</p>
        <div class="ul-div">
          <v-chart theme="macarons" :options="barEqOption" style="margin:0 atuo;" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts';

export default {
  name: 'demoEchart',
  data() {
    return {
      lineOption: {
        xAxis: {
          type: 'category',
          data: [],
        },
        toolbox: {
          show: true,
          title: '详情',
          feature: {
            dataView: {
              readOnly: false,
              optionToContent: function (opt) {
                var axisData = opt.xAxis[0].data;
                var series = opt.series;
                var tableHead = "<table style='width:100%'><tr><th>名称</th><th>次数</th></tr>";
                var tableFoot = '</table>';
                var tableHtml = '';
                axisData.map((item, index) => {
                  tableHtml += `<tr><td>${item}</td><td>${series[0].data[index]}</td></tr>`;
                });
                return tableHead + tableHtml + tableFoot;
              },
            },
          },
        },
        yAxis: {
          name: '次数',
          type: 'value',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#4578ed',
            },
            itemStyle: {
              color: '#4578ed',
            },
          },
        ],
      },
      lineTOption: {},
      barEqOption: {
        color: ['#4578ed'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        toolbox: {
          show: true,
          title: '详情',
          feature: {
            dataView: {
              readOnly: false,
              optionToContent: function (opt) {
                console.log(opt);
                var axisData = opt.xAxis[0].data;
                var series = opt.series;
                var tableHead = "<table style='width:100%'><tr><th>名称</th><th>次数</th></tr>";
                var tableFoot = '</table>';
                var tableHtml = '';
                axisData.map((item, index) => {
                  tableHtml += `<tr><td>${item}</td><td>${series[0].data[index]}</td></tr>`;
                });
                return tableHead + tableHtml + tableFoot;
              },
            },
          },
        },
        grid: {
          left: '3%',
          right: '8%',
          bottom: '16%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '次数',
          },
        ],
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 10,
          },
          {
            type: 'slider',
            start: 0,
            end: 10,
          },
        ],
        series: [
          {
            name: '数量',
            type: 'bar',
            barWidth: '25',
            data: [],
            itemStyle: {
              color: '#4578ed',
              barBorderRadius: 5,
              shadowBlur: 5,
              shadowColor: '#3a6eaf8f',
            },
          },
        ],
      },
      barEqSHOption: {},
      barEqZJOption: {},
      pieUseOption: {
        backgroundColor: 'transparent',
        // title: {
        //   text: '利用率',
        //   left: 'center',
        //   top: 10,
        //   textStyle: {
        //     color: '#3a6eaf',
        //   },
        // },
        legend: {
          top: 20,
          left: 'center',
        },
        toolbox: {
          show: true,
          title: '详情',
          feature: {
            dataView: {
              readOnly: false,
            },
          },
        },
        color: ['#4578ed', '#8aa6e5'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },

        // visualMap: {
        //   show: false,
        //   min: 0,
        //   max: 20,
        //   inRange: {
        //     colorLightness: [0, 1],
        //   },
        // },
        series: [
          {
            name: '利用率',
            type: 'pie',
            radius: '66%',
            center: ['50%', '60%'],
            data: [],
            // roseType: 'radius',
            label: {
              color: '#4578ed',
            },
            minAngle: 10,
            labelLine: {
              lineStyle: {
                color: '#4578ed',
              },
              smooth: 0.2,
              length: 10,
              length2: 20,
            },

            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDelay: function (idx) {
              return Math.random() * 200;
            },
          },
        ],
      },
    };
  },
  components: {
    'v-chart': ECharts,
  },
  created() {
    //  this.barEqZJOption.
  },
  mounted() {
    this.$nextTick(() => {});
    // this.lineTOption = this.$until.deepCopy(this.lineOption);
    // this.barEqSHOption = this.$until.deepCopy(this.barEqOption);
    this.barEqZJOption = this.$until.deepCopy(this.barEqOption);
    this.barEqZJOption.yAxis[0].name = '总价';
    this.barEqZJOption.series[0].name = '总价';
    this.barEqZJOption.tooltip = {
      formatter: function (params, ticket, callback) {
        let data = params.data;
        return `${params.name}<br />数量：${data.num}<br />价格：${data.price}<br />总价：${data.value}`;
      },
    };
    // this.getStudentApply()
    // this.getProvince()
    this.room_use();
    // this.teacher_class();
    // this.student_sign();
    this.room_device();
    // this.device_wear();
    this.device_capital();
  },
  methods: {
    async room_use() {
      let res = await this.$api.query.room_use();
      if (res.code == 0 && res.data && res.data.avg_rate) {
        let data = [
          { value: res.data.avg_rate, name: '已利用' },
          { value: 1 - res.data.avg_rate, name: '未利用' },
          // { value: res.data.use.free, name: '空闲' },
        ];
        this.pieUseOption.series[0].data = data;
      }
    },
    handlePath(path) {
      this.$router.push(path);
    },
    async teacher_class() {
      let res = await this.$api.query.teacher_class();
      if (res.code == 0) {
        let value = res.data.map((item) => {
            return item.count;
          }),
          name = res.data.map((item) => {
            return item.date;
          });
        this.lineTOption.series[0].data = value;
        this.lineTOption.xAxis.data = name;
        // this.$message({
        //   type: 'success',
        //   center: true,
        //   message: '打分成功成功！',
        // });
      }
    },
    async student_sign() {
      let res = await this.$api.query.student_sign();
      if (res.code == 0) {
        let value = res.data.map((item) => {
            return item.count;
          }),
          name = res.data.map((item) => {
            return item.date;
          });
        this.lineOption.series[0].data = value;
        this.lineOption.xAxis.data = name;
        // this.$message({
        //   type: 'success',
        //   center: true,
        //   message: '打分成功成功！',
        // });
      }
    },
    async room_device() {
      let res = await this.$api.query.room_device();
      if (res.code == 0) {
        let value = res.data.map((item) => {
            return item.device_num;
          }),
          name = res.data.map((item) => {
            return item.device_name;
          });
        this.barEqOption.series[0].data = value;
        this.barEqOption.xAxis[0].data = name;
        let space = (5 / value.length) * 100;
        this.barEqOption.dataZoom[0].end = space > 100 ? 100 : space;
        this.barEqOption.dataZoom[1].end = space > 100 ? 100 : space;
      }
    },
    async device_wear() {
      let res = await this.$api.query.device_wear();
      if (res.code == 0) {
        let value = res.data.map((item) => {
            return item.device_num;
          }),
          name = res.data.map((item) => {
            return item.device_name;
          });
        this.barEqSHOption.series[0].data = value;
        this.barEqSHOption.xAxis[0].data = name;
        let space = (5 / value.length) * 100;
        this.barEqSHOption.dataZoom[0].end = space > 100 ? 100 : space;
        this.barEqSHOption.dataZoom[1].end = space > 100 ? 100 : space;
        // this.$message({
        //   type: 'success',
        //   center: true,
        //   message: '打分成功成功！',
        // });
      }
    },
    async device_capital() {
      let res = await this.$api.query.device_capital();
      if (res.code == 0) {
        let value = res.data.map((item) => {
            return { value: item.device_num * item.device_price, num: item.device_num, price: item.device_price };
          }),
          name = res.data.map((item) => {
            return item.device_name;
          });
        this.barEqZJOption.series[0].data = value;
        this.barEqZJOption.xAxis[0].data = name;
        let space = (5 / value.length) * 100;
        this.barEqZJOption.dataZoom[0].end = space > 100 ? 100 : space;
        this.barEqZJOption.dataZoom[1].end = space > 100 ? 100 : space;
        // this.$message({
        //   type: 'success',
        //   center: true,
        //   message: '打分成功成功！',
        // });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.echarts {
  margin: 0 auto;
  width: inherit;
  height: inherit;
}
.flex-div {
  width: 100%;
  // padding: 8px 0;
  // min-height: 500px;
  display: flex;
  flex-wrap: wrap;
  .f-item,
  .f-item1 {
    margin: 4px;
    background: #e6edf5;
    width: calc(50% - 8px);
    // height: 400px;
    box-shadow: 0 0 3px 2px #b9b9b9;
    cursor: pointer;
    padding: 16px 12px;
    box-sizing: border-box;
    // margin-right: 8px;
    .div-style {
      display: flex;
      padding: 16px;
      border-radius: 4px;
      background: #ffffff;
      margin-top: 16px;
      height: calc(100% - 72px);
      overflow: auto;
      div {
        width: 451px;
        height: 308px;
        overflow: hidden;

        // background:#ccc;
      }
    }
    .ul-div {
      padding: 16px;
      margin-top: 16px;
      width: calc(100% - 32px);
      // height: calc(100% - 72px);
      height: 360px;
      background: #ffffff;
      border-radius: 4px;
      overflow: hidden;
      .ul-style {
        list-style: none;
        li {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          margin-bottom: 12px;
          .p-l {
            width: 320px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
          }
          .p-l:hover {
            color: #6d4827;
            text-decoration: underline;
          }
          .p-r {
            color: #8c8c8c;
            text-align: right;
          }
        }
      }
    }

    .p-title {
      font-size: 16px;
      color: #4578ed;
      letter-spacing: 2px;
      // font-weight: bold;
      i {
        font-size: 18px;
        vertical-align: bottom;
        margin-right: 4px;
      }
      // font-style: italic;
      // font-weight: bold;
    }
  }
  .f-item1 {
    width: 934px;
    margin-right: 0;
  }
  // .f-item:nth-child(2n) {
  //   margin-right: 0px;
  // }
  .f-item:hover {
    box-shadow: 0 0 3px 1px #b9b9b9;
  }
}
.pageHeader:before {
  width: 100px;
}
.pageHeader {
  margin-bottom: 12px;
}
.tt {
  width: 100%;
}
</style>
